import { createStore, applyMiddleware, compose, PreloadedState } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import { PersistPartial } from 'redux-persist/es/persistReducer'
import { createFilter } from 'redux-persist-transform-filter'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import { devToolsEnhancer } from 'redux-devtools-extension'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import createRootReducer, { AppState } from './rootReducer'

// Infer the `AppDispatch` types from the store itself
export type AppDispatch = typeof store.dispatch

export const history = createBrowserHistory()

const configureStore = (
  preloadedState?: PreloadedState<AppState & PersistPartial>
) => {
  // Filter out the variables to be saved in the localStorage
  const saveFavorisSubsetFilter = createFilter('favoris', [
    'doNotShowModalSupprimerFavoris',
  ])

  // Config for redux-persist to store data in localStorage
  const persistConfig = {
    key: 'geociblage_root',
    storage,
    stateReconciler: autoMergeLevel2,
    // whitelist = reducers to be persisted
    whitelist: ['favoris'],
    transforms: [saveFavorisSubsetFilter],
  }

  const persistedReducer = persistReducer<AppState>(
    persistConfig,
    createRootReducer(history)
  )

  const appStore = createStore(
    persistedReducer,
    preloadedState,
    compose(
      devToolsEnhancer({
        trace: true,
        traceLimit: 25,
      }),
      applyMiddleware(
        routerMiddleware(history) // for dispatching history actions
        // ... other middlewares ...
      )
    )
  )
  return appStore
}

const store = configureStore(/* provide initial state if any */)

export const persistor = persistStore(store)

export default store
